module.exports = __webpack_public_path__ + "img/baicoin.977137c7.jpeg";